import { render } from "./CampaignsContent.vue?vue&type=template&id=65b60cb0&scoped=true&ts=true"
import script from "./CampaignsContent.vue?vue&type=script&lang=ts"
export * from "./CampaignsContent.vue?vue&type=script&lang=ts"

import "./CampaignsContent.vue?vue&type=style&index=0&id=65b60cb0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b60cb0"]])

export default __exports__